import { useTranslation } from 'react-i18next';
import { TriangleAlert } from 'lucide-react';
import { Button } from '@/ui';
import { formatRemaining } from '@/lib/task-phase';
import styles from './PaymentDue.module.css';

/**
 * MUSTERININ ODEME UYARISI (2026-09-26).
 *
 * Onaylanan teklifin odemesi 15 dakika icinde yapilmazsa is incelemeye ('warning') alinir;
 * oysa karttaki tek sinyal kucuk bir faz rozetiydi ve musteri odemeyi unutabiliyordu. Iki parca:
 *   - PaymentDueNotice : 'pending' kartin/sayfanin icinde, kalan sureyle (mm:ss).
 *   - PaymentDueBanner : Acik Talepler'in ustunde, odemesi bekleyen onayli is SAYISIYLA.
 *                        Dugmesi "Islemde" sekmesine goturur (2026-10-02'ye kadar adi
 *                        "Onaylanan"di; sekme anahtari ayni: 'approvedRequests').
 *
 * Canli bolge (aria-live / role=alert) YOK: metin saniyede bir degisiyor; konusan bir ekran
 * okuyucu sayfadaki her seyin ustune binerdi (CountdownRing ile ayni gerekce).
 */

export type PaymentDueNoticeProps = {
  /** Odeme penceresinde kalan sure (ms) — yasayan faz (useCountdown). */
  remainingMs: number;
  /** "Odeme bilgileri" eylemi. Verilmezse dugme cizilmez (bilgi zaten ayni ekrandaysa). */
  onAction?: (() => void) | undefined;
};

export function PaymentDueNotice({ remainingMs, onAction }: PaymentDueNoticeProps) {
  const { t } = useTranslation();

  return (
    <section className={styles.notice} aria-label={t('paymentDue.title')}>
      <div className={styles.text}>
        <p className={styles.title}>
          <TriangleAlert size={14} strokeWidth={2.2} aria-hidden="true" />
          {t('paymentDue.title')}
        </p>
        <p className={styles.body}>
          {t('paymentDue.body', { time: formatRemaining(remainingMs) })}
        </p>
      </div>
      {onAction ? (
        <Button tone="danger" size="sm" onClick={onAction}>
          {t('paymentDue.cta')}
        </Button>
      ) : null}
    </section>
  );
}

export type PaymentDueBannerProps = {
  /** Odemesi beklenen onayli ('pending') talep sayisi. */
  count: number;
  /** Islemde sekmesine ('approvedRequests') gecis. */
  onAction: () => void;
};

export function PaymentDueBanner({ count, onAction }: PaymentDueBannerProps) {
  const { t } = useTranslation();

  return (
    <section className={styles.banner} aria-label={t('paymentDue.title')}>
      <p className={styles.bannerText}>
        <TriangleAlert className={styles.icon} size={16} strokeWidth={2.2} aria-hidden="true" />
        {t('paymentDue.banner', { count })}
      </p>
      <Button tone="danger" size="sm" onClick={onAction}>
        {t('paymentDue.bannerCtaInProgress')}
      </Button>
    </section>
  );
}
